import type { CommonApi } from '@/v2/services/types';
import type { UI } from '@/v2/types';
import React from 'react';

import { BEST_RATE_TEXT } from '@shared/v2/constants/packages';

import Button from '@/components/Button';
import Modal from '@/v2/components/layout/Modal';
import RoomOptionDetails from '@/v2/components/pages/PackageViewV2/components/RoomOptionDetails';

type AlternativeOptionModalProps = {
  offer: UI.RoomOptionOffer;
  roomType: CommonApi.ParsedResponse.RoomType;
  packageName?: string;
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
  onSubmit: () => void;
};

const AlternativeOptionModal = ({
  offer,
  isOpen,
  roomType,
  packageName,
  onClose,
  onSubmit,
  onCancel,
}: AlternativeOptionModalProps) => {
  return isOpen ? (
    <Modal onClose={onClose}>
      <Modal.Header>Other package option</Modal.Header>
      <Modal.Body p="3">
        <RoomOptionDetails
          title="Other package option"
          offer={offer}
          roomType={roomType}
          packageName={packageName ?? BEST_RATE_TEXT}
        />
        <Button variant="primary" mt="6" block dialogue onClick={onSubmit}>
          Select package
        </Button>
        <Button variant="auxiliary" mt="4" block dialogue onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Body>
    </Modal>
  ) : null;
};
export default AlternativeOptionModal;
